import React from "react";

const RemoveEmail = (props: any) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 67 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M46.8 1.86669C35.2 8.26669 40.1334 26.6667 53.3334 26.6667C60.1334 26.6667 66.6667 20.1334 66.6667 13.4667C66.6667 3.46669 55.6 -3.06665 46.8 1.86669ZM60.6667 6.00002C62.8 8.00002 64 10.8 64 13.3334C64 15.8667 62.8 18.6667 60.6667 20.6667C58.6667 22.8 55.8667 24 53.3334 24C50.8 24 48 22.8 46 20.6667C43.8667 18.6667 42.6667 15.8667 42.6667 13.3334C42.6667 10.8 43.8667 8.00002 46 6.00002C48 3.86669 50.8 2.66669 53.3334 2.66669C55.8667 2.66669 58.6667 3.86669 60.6667 6.00002Z"
        fill="black"
      />
      <path
        d="M45.3333 13.3334C45.3333 14.1334 48.9333 14.6667 53.3333 14.6667C57.7333 14.6667 61.3333 14.1334 61.3333 13.3334C61.3333 12.5334 57.7333 12 53.3333 12C48.9333 12 45.3333 12.5334 45.3333 13.3334Z"
        fill="black"
      />
      <path
        d="M0 33.3333V57.3333H33.3333H66.6667V39.8667C66.6667 28.6667 66.1333 22.8 65.3333 23.3333C64.5333 23.7333 64 29.6 64 36.1333V48.1333L55.3333 41.2C47.2 34.5333 46.8 34 48.9333 31.7333C53.0667 27.0667 47.8667 29.2 41.7333 34.6667C38.4 37.6 34.6667 40 33.3333 40C30.5333 40 2.66667 16.1333 2.66667 13.7333C2.66667 12.4 6.53333 12 20 12C30.6667 12 37.3333 11.4667 37.3333 10.6667C37.3333 9.86667 30.2667 9.33334 18.6667 9.33334H0V33.3333ZM12.4 27.0667L20.1333 34.1333L11.3333 41.0667L2.66667 48.1333V34C2.66667 26.2667 3.06667 20 3.73333 20C4.26667 20.1333 8.13333 23.3333 12.4 27.0667ZM33.3333 42.6667C34.4 42.6667 37.4667 41.2 40.1333 39.4667L44.9333 36.2667L54.1333 43.6C59.2 47.6 63.4667 51.7333 63.7333 52.8C64.1333 54.4 59.3333 54.6667 33.3333 54.6667C7.33333 54.6667 2.53333 54.4 2.93333 52.8C3.2 51.7333 7.46667 47.6 12.5333 43.6L21.7333 36.2667L26.5333 39.4667C29.2 41.2 32.2667 42.6667 33.3333 42.6667Z"
        fill="black"
      />
    </svg>
  );
};

export default RemoveEmail;
